import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getImageUrl } from '../../utils/images'
import { BrandListing } from '../ReusableComponents/BrandListing.Component'
import { CheckuserExistsForm } from './CheckuserExistsForm'

export const AuthorizeUser = () => {
  const navigator = useNavigate();

  const [selectedTab, setSelectedTab] = useState(1)
  const [pageNo, setPageNo] = useState(1)
  
    const { emailId: encodedId } = useParams()
  
    let emailId = ''
  
    try {
      emailId =  encodedId
    } catch (error) {
      emailId = ''
    }


    console.log("emailIDemailID",emailId)
  const [subDropDown, setSubDropDown] = useState({
      index: 0,
      isShow: false
  })
  const [leadCount, setLeadCount] = useState({})

  const [searchText, setSearchText] = useState('')



  return (
   <div> <section class="login">
   <div class="container-fluid">
     <div class="row">
       <div class="col-12 col-lg-6 px-0 d-none d-lg-block">
         <div class="left-login-bg">
           <img  src={getImageUrl('login-image.svg')} alt="img" class="w-100" />
           <div class="login-image-title">
             <div class="text-center">
               <img src={getImageUrl('ue.svg')}  alt="img" class="w-35" /><br />
               <img src={getImageUrl('LOYALTY-PROGRAM.svg')}  alt="img" class="w-28 mt-4" />
             </div>
           </div>
         </div>
       </div>
       <div class="col-12 col-lg-6">
         <CheckuserExistsForm emailId={emailId}/>
       </div>
     </div>
   </div>
 </section></div>
  )
}
